import { Select, TextField } from '@material-ui/core';
import styled from 'styled-components';

import theme from 'constants/theme';

export const Container = styled.div`
  padding: 1rem 1.5rem 1rem 1.5rem;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
`;

export const TableRow = styled.tr`
  &:first-child {
    td {
      border-width: 1px 1px 1px 0px;
      &:first-child {
        border-width: 1px;
      }
    }
  }
`;

export const TableCell = styled.td`
  border: 1px solid rgb(227, 235, 239);
  border-width: 0 1px 1px 0;
  padding: 4px 12px;
  text-align: center;
  color: #777;
  &:first-child {
    border-width: 0 1px 1px 1px;
  }
`;

export const StyledSelect = styled(Select)`
  margin-top: 3.5px;
  min-width: ${(props) => props.width ?? '75%'};
  width: ${(props) => props.width ?? '75%'};
  .MuiSelect-select {
    padding: 9px 32px 11px 16px;
    font-size: 0.9rem;
  }
  fieldset {
    border-color: ${theme.palette.borders.lighterGrey};
  }
`;

export const Tabs = styled.ul`
  margin: 1rem 0;
  padding: 0;
  text-align: center;
`;

export const Tab = styled.li`
  display: inline-block;
  border: 1px solid #e1e1e1;
  border-width: 1px 1px 1px 0;
  padding: 0.4rem 0rem;
  max-width: 27.5%;
  cursor: pointer;
  color: #777;
  &:hover {
    background: #eee;
  }

  &:first-child {
    border-width: 1px;
    border-radius: 3px 0 0 3px;
  }
  &:last-child {
    border-radius: 0 3px 3px 0;
  }
  ${({ active }) =>
    active &&
    `
      font-weight: 500;
      color: #3a8ee9;
      background: #e5f6fd;
    `};
  svg {
    font-size: 1.25rem;
    vertical-align: top;
    margin-right: 3px;
  }
  ${({ disabled }) =>
    disabled &&
    `
  pointer-events: none;
    `}
`;

export const TabLabel = styled.span`
  display: inline-block;
  vertical-align: top;
`;

export const DashedButton = styled.div`
  border: 1.5px dashed #e3ebef;
  color: #333;
  text-align: center;
  padding: 0.5rem;
  cursor: pointer;
  margin: 1rem 0 1.5rem 0;
  &:hover {
    background: #fafafa;
  }
`;

export const CheckboxesContainer = styled.div`
  border: 1px solid #e3ebef;
  padding: 0.25rem 0.75rem 0.1rem 0.75rem;
  margin: 1rem 0 0 0;
  color: #333;
  .MuiTextField-root {
    margin: 0 0.75rem;
    vertical-align: sub;
  }
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
    text-align: center;
    padding: 7px 8px;
    width: 3rem;
    text-align: center;
    color: #333;
  }
  label {
    &.marginLeft {
      margin-left: 1rem;
    }
  }
  .MuiTypography-root {
    font-size: 0.9rem;
  }
`;

export const Separator = styled.hr`
  border: 0;
  border-bottom: 1px solid #e3ebef;
  margin: 0.1rem 0.5rem 0.1rem 0;
`;

export const Scale = styled.div`
  border: 1px solid #e3ebef;
  display: inline-block;
  margin-top: 0.5rem;
  span {
    display: table-cell;
    width: 58px;
    height: 36px;
    border-right: 1px solid #e3ebef;
    line-height: 36px;
    color: #3a8ee9;
    font-weight: 500;
    &:last-child {
      border-right: none;
    }
  }
`;

export const RatingTextField = styled(TextField)`
  display: block;
  .MuiInputBase-root {
    padding: 0;
  }
  input,
  textarea {
    padding: 6px 8px;
    font-size: 0.8rem;
    width: 94px;
    text-align: center;
  }
  fieldset {
    border-color: #e8e8e8;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${({ score }) =>
    score &&
    `
    input{
      padding: 7px 8px;
      width: 65px;
    }
    margin-top: 1rem;
  `};
`;

export const Dash = styled.div`
  width: 40px;
  height: 8px;
  border-radius: 14px;
  background-color: ${theme.palette.background.lightGrey3};
`;
